import { render, staticRenderFns } from "./Game5-4.vue?vue&type=template&id=57e2dbf0&scoped=true&"
import script from "./Game5-4.vue?vue&type=script&lang=js&"
export * from "./Game5-4.vue?vue&type=script&lang=js&"
import style0 from "./Game5-4.vue?vue&type=style&index=0&id=57e2dbf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e2dbf0",
  null
  
)

export default component.exports